export default __webpack_public_path__ + "0248f6d2d5415b1b62d04c57a3de4f9924ab6676/206052ae2e9a0890080884cbd9995409.png";